<h1 mat-dialog-title>{{title}}
  <sfc-icon name="rds-icon-times" size="xs" class="clickable" (click)="close()">
  </sfc-icon>
</h1>
<div mat-dialog-content>
  <div *ngIf='hasData ; else errorTextField'>
    <div class="details-name wide" *ngIf='showCreditorListingsTable'>Goedgekeurde/Geblokkeerde incassant(en):
        <ng-container #creditorListingsTable></ng-container>
        <br>
    </div>
    <div class="details-name wide" *ngIf='showMandateListingsTable'>Goedgekeurde/Geblokkeerde machtiging(en):
        <ng-container #mandateListingsTable></ng-container>
        <br>
    </div>
    <div class="details-name wide" *ngIf='showRestrictedMandateListingsTable'>Beperkte machtiging(en):
        <ng-container #restrictedMandateListingsTable></ng-container>
        <br>
    </div>
    <div class="details-name wide" *ngIf='showRestrictedCountryListings'>Landen van waaruit niet kan worden geincasseerd:
        <ul *ngFor="let country of data.detailsViewObject.restrictedCountryListings;">
          <li> {{country.countryDescription}} </li>
        </ul>
    </div>
  </div>
</div>

<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
